module.exports = __webpack_public_path__ + "img/kuang1.eb5e9a71.png";